import { render, staticRenderFns } from "./DoublePieCharts.vue?vue&type=template&id=5ca44be0&scoped=true"
import script from "./DoublePieCharts.vue?vue&type=script&lang=js"
export * from "./DoublePieCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca44be0",
  null
  
)

export default component.exports